import API from '../api/index';

const getAvailablePlans = () => API.get('plans');
const getPlan = (_id: string) => API.get(`/plans/${_id}`);
const downloadInvoice = (_id: string) => API.get(`/invoice/${_id}`, { responseType: 'arraybuffer' });
const cancelSubscription = () => API.post('/cancelSubscription');
const reactivateSubscription = () => API.post('/reactivateSubscription');
const getPlanData = (_id: string) => API.get(`/plan${_id}`);
const changePlan = (planId: string) => API.patch('/changePlan', { planId });
const getAvailablePacks = () => API.get('packs');
const purchaseWAPack = (packId: string) => API.post('/purchaseWAPack', { packId });
const cancelWAPack = (invoiceId: string) => API.post('/cancelWAPack', { invoiceId });
const getWAPacks = (_id: string) => API.get(`/getWAPacks${_id}`);
const getWAMessages = (_id: string) => API.get(`/getWAMessages${_id}`);

const StripeService = {
    getAvailablePlans,
    getPlan,
    downloadInvoice,
    cancelSubscription,
    reactivateSubscription,
    changePlan,
    getPlanData,
    getAvailablePacks,
    purchaseWAPack,
    cancelWAPack,
    getWAPacks,
    getWAMessages
};

export default StripeService;